import React from 'react';
import { centimetersToInches as cmToInches } from 'src/utils/conversion';

const ResultPresentation = ({ closestSize, downSize, upSize, unit, className = '' }) => {
    const hasAnySize = !!closestSize || !!downSize || !!upSize;
    const showInches = unit === 'in';
    return (

        <svg viewBox="0 0 409.1252 260.2347" fill="none" className={className}>
            <circle cx="98.5" cy="98.5" r="98.5" fill="#E8E8E8" />

            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="22" y="48" width="153" height="153">
                <g clipPath="url(#clip0)">
                    <path d="M82.1124 112.188C82.0838 112.085 82.0635 112.2 82.0399 112.095C85.9728 101.929 72.7525 96.0994 80.1055 80.4249C86.6625 66.4393 115.103 75.7911 107.843 102.415C103.612 117.932 103.875 122.313 105.728 121.058C109.887 118.241 105.47 106.241 110.035 99.4805C115.326 91.6407 129.986 94.4897 131.813 106.655C133.836 120.11 122.289 132.181 124.74 134.406C125.898 135.458 128.74 132.187 129.501 125.514C130.222 119.183 132.938 114.998 137.958 114.222C148.31 112.623 153.524 121.08 154.148 128.992C155.04 140.264 142.849 152.301 146.286 153.093C151.104 154.202 149.084 136.985 156.354 134.798C166.652 131.702 180.886 143.081 170.774 171.347C167.158 181.449 167.895 187.317 167.674 194.539C168.639 203.841 168.854 214.674 166.939 225.575L23.1247 220.103C23.2748 204.479 21.9999 170.22 26.4522 160.191C29.7576 152.732 33.4679 131.717 29.2517 125.18C25.0355 118.644 23.3018 107.438 27.2144 96.2391C31.127 85.0402 35.1004 51.9266 57.0785 50.7598C77.161 49.6939 77.4173 99.0393 76.9501 104.175C76.5268 108.82 80.1663 114.643 82.2035 111.902" fill="#B7B7B7" />
                </g>
            </mask>

            <g mask="url(#mask0)">
                <circle cx="98.5" cy="98.5" r="98.5" fill="#B7B7B7" />
            </g>

            <defs>
                <clipPath id="clip0">
                    <rect width="153" height="153" fill="white" transform="translate(22 48)" />
                </clipPath>
            </defs>

            <g>
                <line x1="33.75" y1="29.25" x2="201.25" y2="29.25" stroke="#9D9D9D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3 5" />
                <text x="210" y="29" fill="black" style={{ dominantBaseline: 'middle' }}>
                    <tspan fill="#9D9D9D" style={{ fontWeight: 'bold', fontSize: '14px', letterSpacing: '1.3' }}>
                        {upSize && upSize.skateSize && `Skate Size ${upSize.skateSize}`}
                    </tspan>
                    <tspan fill="#9D9D9D">&mdash;</tspan>
                    <tspan fill="#9D9D9D" style={{ fontSize: '14px', fontWeight: 'lighter', letterSpacing: '0' }}>
                        {upSize.cm && (showInches ? cmToInches(upSize.cm) : `${upSize.cm} cm`)}
                        {!upSize && (!hasAnySize ? 'Closest above fit' : 'No size avalible')}
                    </tspan>
                </text>
            </g>


            <g>
                <line x1="33" y1="51.5" x2="202" y2="51.5" stroke="#47C1E5" strokeWidth="3" />
                <text x="210" y="51.8" fill="black" style={{ dominantBaseline: 'middle' }}>
                    <tspan style={{ fontWeight: 'bold', fontSize: '14px', letterSpacing: '1.3' }}>
                        {closestSize && `Skate Size ${closestSize.skateSize}`}
                    </tspan>
                    <tspan>&mdash;</tspan>
                    <tspan style={{ fontSize: '14px', fontWeight: 'lighter', letterSpacing: '0' }}>
                        {closestSize.cm && (showInches ? cmToInches(closestSize.cm) : `${closestSize.cm} cm`)}
                        {!closestSize && (!hasAnySize ? 'Closest fit' : 'No size avalible')}
                    </tspan>
                </text>
            </g>


            <g>
                <line x1="33.75" y1="73.25" x2="201.25" y2="73.25" stroke="#9D9D9D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3 5" />
                <text x="210" y="73.5" fill="black" style={{ dominantBaseline: 'middle' }}>
                    <tspan fill="#9D9D9D" style={{ fontWeight: 'bold', fontSize: '14px', letterSpacing: '1.3' }}>
                        {downSize && downSize.skateSize && `Skate Size ${downSize.skateSize}`}
                    </tspan>
                    <tspan fill="#9D9D9D">&mdash;</tspan>
                    <tspan fill="#9D9D9D" style={{ fontSize: '14px', fontWeight: 'lighter', letterSpacing: '0' }}>
                        {downSize.cm && (showInches ? cmToInches(downSize.cm) : `${downSize.cm} cm`)}
                        {!downSize && (!hasAnySize ? 'Closest below fit' : 'No size avalible')}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};

export default ResultPresentation;
